import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import UserLearningDueDate from '../../../../components/UserLearningBlock/components/UserLearningDueDate/UserLearningDueDate';
import styled from '../../../../styled';
import { colorsPalette, SMALL_MARGIN_PX } from '../../../../theme';
import { AnnouncementEntity, NotificationType } from '../../../../types';
import Notification, { AnnouncementType } from './Notification';

const NotificationFabric: FC<{ item: AnnouncementEntity }> = ({ item }) => {
  const { t } = useTranslation();

  if (item.__typename === 'NotificationForAssignment') {
    const assignment = item?.assignment;
    const isNew = item.type === NotificationType.New;
    const title = `${t(
      isNew ? 'page.assignedLearnings.newAssignment' : 'page.assignedLearnings.reminder',
    )} - ${assignment?.title}`;

    return (
      <StyledNotification
        key={item?.id}
        link={`/assigned-learning#${assignment?.id}`}
        title={title}
        subtitle={<StyledUserLearningDueDate dueDate={assignment?.due_date} />}
        type={item?.type}
        highlighted={item?.is_highlighted}
      />
    );
  }

  if (item.__typename === 'Pathway') {
    return (
      <StyledNotification
        key={item?.id}
        title={item?.name}
        subtitle={[
          `${item?.count_videos} ${t('common.videoModules')}`,
          item?.categories?.[0]?.title,
        ]
          .filter(Boolean)
          .join(' • ')}
        link={`/pathway/${item?.slug}`}
        type={AnnouncementType.Pathway}
        highlighted={item?.is_highlighted}
      />
    );
  }

  if (item.__typename === 'Video') {
    return (
      <StyledNotification
        key={item?.id}
        title={item?.title}
        subtitle={[item?.user?.name, item?.categories?.[0]?.title].filter(Boolean).join(' • ')}
        link={`/videos/${item?.video_url}/`}
        type={AnnouncementType.Video}
        highlighted={item?.is_highlighted}
      />
    );
  }

  return null;
};

export default NotificationFabric;

const StyledUserLearningDueDate = styled(UserLearningDueDate)`
  && {
    color: ${colorsPalette.gray};
    font-size: inherit;
  }
`;
const StyledNotification = styled(Notification)`
  &:not(:last-of-type) {
    margin-bottom: ${SMALL_MARGIN_PX};
  }
`;
